import { ExplorerPlus } from '~/api/repository'

export const explorerPlusApi = new ExplorerPlus({
  BASE: import.meta.env.VITE_APP_API,
  HEADERS: {
    'Accept-Language': 'en-US', // TODO: 추후 언어별로 변경
  }
})